import { render } from "./HeroiconsSolidThumbDown.vue?vue&type=template&id=0f6e73d4"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidThumbDown.vue"]])

export default __exports__